module.exports = __webpack_public_path__ + "img/user_bg_zh.e000e342.png";